import { email, required, requiredIf } from 'vuelidate/lib/validators'

const agentStudentOnboardDateIsRequired = function () {
  return this.ddlAgent !== 'NIL'
}
// Bhutan: no Fin / PR IC, the expiry date belongs to the residency status instead.
const studentIdExpiryDateIsRequired = function () {
  return this.isBhutanSchool ? this.bhutanResidencyRequiresExpiry : this.oneFinType
}
const studentIdNoIsRequired = function () {
  return !this.isBhutanSchool && this.oneFinType
}

const studentValidations = {
  inputStudentFirstName: { required },
  ddlStudentGender: { required },
  inputStudentLastName: { required },
  ddlStudentNationality: { required },
  inputStudentDateOfBirth: { required },
  //ddlStudentSelectLevel: {required},
  inputFirstCommencementDate: { required },
  ddlStudentResidencyStatus: { required },
  ddlAgent: { required },
  inputAgenStudentOnboardtDate: { requiredIf: requiredIf(agentStudentOnboardDateIsRequired) },
  //ddlStudentFirstAcademicYear: {required},
  ddlStudentPayer: { required },

  ddlStudentLevel: { requiredIf: requiredIf('isLevelTab') },
  ddlStudentClass: { requiredIf: requiredIf('isLevelTab') },

  //ddlStudentIntakeYear: {required},
  inputStudentAddress1: { required },
  inputStudentPostalCode: { required },
  inputStudentCorrespondanceAddress1: { required },
  inputStudentCorrespondancePostalCode: { required },
  inputStudentEmail: { required },
  ddlStudentFrequentPayments: { required },

  inputStudentIdentificationExpiryDate: { requiredIf: requiredIf(studentIdExpiryDateIsRequired) },
  inputStudentIdentificationNo: { requiredIf: requiredIf(studentIdNoIsRequired) },

  inputStudentPassport: { requiredIf: requiredIf('onePassportType') },
  inputStudentPassportExpiryDate: { requiredIf: requiredIf('onePassportType') },

  inputStudentBirthCertificate: { requiredIf: requiredIf('oneIDType') },
  inputStudentIC: { requiredIf: requiredIf('oneIDType') },

  inputFatherFirstName: { requiredIf: requiredIf('isdivParent') },
  inputFatherLastName: { requiredIf: requiredIf('isdivParent') },
  inputMotherFirstName: { requiredIf: requiredIf('isdivParent') },
  inputMotherLastName: { requiredIf: requiredIf('isdivParent') },

  inputFatherOccupation: { requiredIf: requiredIf('fatherOccupation') },
  inputFatherCompanyName: { requiredIf: requiredIf('fatherOccupation') },
  inputFatherCompanyAddresseeName: { requiredIf: requiredIf('fatherOccupation') },
  inputMotherOccupation: { requiredIf: requiredIf('motherOccupation') },
  inputMotherCompanyName: { requiredIf: requiredIf('motherOccupation') },
  inputMotherCompanyAddresseeName: { requiredIf: requiredIf('motherOccupation') },

  inputStudentEnrolledCenterName: { requiredIf: requiredIf('isdivEnrolledinOtherCenter') },
  ddlStudentEnrolledCenterType: { requiredIf: requiredIf('isdivEnrolledinOtherCenter') },

  inputFatherEmail: { requiredIf: requiredIf('isNewParent'), email },
  inputFatherCompanyEmail: { email },
  inputMotherEmail: { requiredIf: requiredIf('isNewParent'), email },
  inputMotherCompanyEmail: { email },

  inputStudentEmailAdd: { email },

  validationGroupSave: [
    'inputStudentFirstName',
    'inputStudentLastName',
    'ddlStudentNationality',
    'inputStudentDateOfBirth',
    'inputFirstCommencementDate',
    'ddlStudentResidencyStatus',
    'ddlStudentPayer',
    'inputStudentAddress1',
    'inputStudentPostalCode',
    'ddlAgent',
    'inputAgenStudentOnboardtDate',
    'inputStudentCorrespondanceAddress1',
    'inputStudentCorrespondancePostalCode',
    'inputStudentEmail',
    'inputStudentIdentificationExpiryDate',
    'inputStudentIdentificationNo',
    'inputStudentPassport',
    'inputStudentPassportExpiryDate',
    'inputStudentBirthCertificate',
    'inputStudentIC',
    'inputFatherFirstName',
    'inputFatherLastName',
    'inputMotherFirstName',
    'inputMotherLastName',
    'inputFatherOccupation',
    'inputFatherCompanyName',
    'inputFatherCompanyAddresseeName',
    'inputMotherOccupation',
    'inputMotherCompanyName',
    'inputMotherCompanyAddresseeName',
    'inputStudentEnrolledCenterName',
    'ddlStudentEnrolledCenterType',
    'inputFatherEmail',
    'inputFatherCompanyEmail',
    'inputMotherEmail',
    'inputMotherCompanyEmail',
    'ddlStudentFrequentPayments',
  ],

  validationGroupBillingEmail: ['inputStudentEmailAdd'],
}

export { studentValidations }
